<div class="input-wrapper">
  @if (!isReadonlySsn4Mode) {
    <input
      type="text"
      [value]="val"
      class="ssn-input"
      spellcheck="false"
      (keydown)="onKeydown($event)"
      (beforeinput)="$event.preventDefault()"
      (paste)="onPaste($event)"
      (input)="onInput($event)"
      (click)="openPanelOptions($event)"
      [disabled]="disabled"
      />
  } @else {
    <input
      type="text"
      (keydown)="onKeydown($event)"
      (beforeinput)="$event.preventDefault()"
      (click)="openPanelOptions($event)"
      [value]="val"
      class="ssn-input"
      spellcheck="false"
      [disabled]="disabled"
      />
  }


  <input
    type="text"
    [matAutocomplete]="auto"
    #autocompleteTriggerRef="matAutocompleteTrigger"
    [matAutocompleteDisabled]="autocompleteDisabled"
    [formControl]="myControl"
    class="hidden-input"
    />
  @if (!checkIsSsn4IsEmpty(value) && !!value && !disabled) {
    <span
      class="reset-btn"
      id="atqa-reset-btn"
      (click)="reset()"
      >
      <i class="material-icons" [class.highlighted]="highlightIfSet">close</i>
    </span>
  }
  <mat-autocomplete
    #auto="matAutocomplete"
    [autoActiveFirstOption]="true"
    [panelWidth]="panelWidth"
    (optionSelected)="onOptionSelected($event)"
    >
    @for (option of filteredOptions | async; track option) {
      <mat-option [value]="option">
        {{ option.formatOption }}
      </mat-option>
    }
  </mat-autocomplete>
</div>
